var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconAttributeUnselected(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.137 11.023a2 2 0 000-2.828L7.804.862A1.985 1.985 0 006.39.277H1.61A1.333 1.333 0 00.277 1.61v4.78a1.985 1.985 0 00.586 1.415l7.333 7.333a2 2 0 002.828 0l4.114-4.115zm-.942-.942l-4.115 4.114a.683.683 0 01-.942 0L1.804 6.862a.667.667 0 01-.194-.472V1.943a.333.333 0 01.334-.333H6.39a.667.667 0 01.472.195l7.333 7.334a.667.667 0 010 .942z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.999 5a1 1 0 100-2 1 1 0 000 2z",
    fill: "currentColor"
  })));
}
export default SvgIconAttributeUnselected;